import { render } from "./CollapseCard.vue?vue&type=template&id=2c3b84d9&scoped=true"
import script from "./CollapseCard.vue?vue&type=script&lang=js"
export * from "./CollapseCard.vue?vue&type=script&lang=js"

import "./CollapseCard.vue?vue&type=style&index=0&id=2c3b84d9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c3b84d9"]])

export default __exports__